import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

// Base selectors
export const selectNotes = (state: RootState) => state.notes
export const selectNoteEntities = (state: RootState) => state.notes.entities
export const selectNoteIds = (state: RootState) => state.notes.ids

// Get all notes as array
export const selectAllNotes = createSelector(
  [selectNoteEntities, selectNoteIds],
  (entities, ids) => ids.map(id => entities[id])
)

// Get note by ID
export const selectNoteById = (noteId: string) => (state: RootState) => 
  state.notes.entities[noteId]

// Get notes by case ID
export const selectNotesByCaseId = (caseId: string) => createSelector(
  [selectNoteEntities, (state: RootState) => state.notes.byCaseId[caseId]],
  (entities, noteIds) => {
    if (!noteIds) return []
    return noteIds.map(id => entities[id]).filter(Boolean)
  }
)

// Get recent notes
export const selectRecentNotes = (limit: number = 5) => createSelector(
  [selectAllNotes],
  (notes) => {
    return [...notes]
      .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())
      .slice(0, limit)
  }
)

// Get note count
export const selectNoteCount = createSelector(
  [selectNoteIds],
  (ids) => ids.length
)
